import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/tracker/type/sleep-score';
const moduleName = 'tracker-type-sleep-score';

export const trackerTypeSleepScore: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-overview`,
    pathTemplate: '{baseTranslateUrl}/overview/{language}'
  }
];
